import { Box, Typography } from "@mui/material";
import { CustomDraggable } from "../Draggable";

const DargableLogo = ({ logo, height, width, divSize }) => {
  console.log("data from dargable logo", height, width);
  return (
    <CustomDraggable
      isToolbox
      width={190}
      height={185}
      left={20}
      top={20}
      bounds={{
        left: 20,
        right: width ? width - divSize : window.innerWidth - 160 - 20,
        top: 20,
        bottom: height ? height - divSize + 60 : window.innerHeight - 155 - 20,
      }}
      customComponent={
        <Box
          sx={{
            width: divSize || 200,
            color: "transparent",
            borderRadius: "0px",
            position: "absolute",
            zIndex: 4,
            paddingBottom: "12px",
            border: `1px solid `,
          }}
        >
          <div
            style={{
              width: "100%",
              cursor: "all-scroll",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 0px",
            }}
            className="draggable-header"
          >
            {logo}
          </div>
        </Box>
      }
    />
  );
};

export default DargableLogo;
